// extracted by css-extract-rspack-plugin
export default {"component":"TextEditor-module__component___AUa7F","linkDecorator":"TextEditor-module__linkDecorator___GpR2w","linkDecoratorAnchor":"TextEditor-module__linkDecoratorAnchor___PSzs6"};